export default __webpack_public_path__ + "static/media/Subtract.0b3f47d2.svg";